import {
    Divider,
    ListItemIcon,
    ListItemText, Menu,
    MenuItem,
} from "@mui/material";
import {useProjectUnitSystem} from "../shopdrawing/ProjectName";
import {useAlternative} from "./alternative/Alternative";
import {useContext, useState} from "react";
import {CreateAlternative} from "./alternative/CreateAlternative";
import {useNavigate, useParams} from "react-router-dom";
import {ManageAlternatives} from "./alternative/ManageAlternative";
import EditIcon from '@mui/icons-material/Edit';
import {Alternative, alternativeLabel} from "../../../api/QuoteAlternatives";
import {EventEmitter} from "nate-react-api-helpers";
import {AddProjectModal} from "../AddProjectModal";
import {AlternativeContext} from "./alternative/AlternativeContext";
import {ArrowDropDown} from "@mui/icons-material";
import {css} from "@emotion/css";

export function QuoteAlternative() {
    const alt = useAlternative();

    const altCtx = useContext(AlternativeContext);
    const list = EventEmitter.reactValue(altCtx.alternatives) || [];
    const altObj = list.find(a => a.id === alt);

    const sys = useProjectUnitSystem();
    const [showCreate, setShowCreate] = useState(false);
    const [showCreateProject, setShowCreateProject] = useState(false);
    const [showManage, setShowManage] = useState<Alternative|null>(null);
    const nav = useNavigate();
    const params = useParams<{workspace: string; project: string}>();
    const [menuAnchor, setMenuAnchor] = useState<any>(null);

    return (
        <div>

            <button className={buttonCss} onClick={(e) => {
                setMenuAnchor(e.currentTarget)
            }}>
                <div style={{
                    fontSize: "0.75rem",
                    textAlign: "center",
                    flex: 1,
                }}>
                    {altObj ? alternativeLabel(altObj) : "(none)"}
                </div>
                <div style={{fontSize: "1rem", height: "1em"}}>
                    <ArrowDropDown fontSize="inherit" color="inherit" />
                </div>
            </button>

            <>
                {menuAnchor && <Menu
                    anchorEl={menuAnchor}
                    onClose={() => setMenuAnchor(null)} open
                    style={{width: 300}}
                >

                    {list.map(i =>
                        <MenuItem key={i.id.toString()}
                                  onClick={() => {
                                      setMenuAnchor(null)
                                      nav(`/project/${params.project}/quote/${i.id}/${params.workspace}`)
                                  }}
                        >
                            <ListItemText>
                                {alternativeLabel(i)}
                                <div style={{
                                    fontSize: "0.75rem",
                                    whiteSpace: "normal",
                                    lineHeight: "1em",
                                }}>{i.description}</div>
                            </ListItemText>

                            <ListItemIcon
                                style={{width: 20, minWidth: 20, paddingLeft: 10}}
                                onClick={e => {
                                e.stopPropagation()
                                setShowManage(i);
                                setMenuAnchor(null)
                            }}>
                                <EditIcon fontSize="small" />
                            </ListItemIcon>
                        </MenuItem>)}
                    <Divider />
                    <MenuItem value="-" onClick={() => {
                        setShowCreate(true)
                    }}>
                        Create New
                    </MenuItem>
                    <MenuItem value="-" onClick={() => {
                        setShowCreateProject(true)
                    }}>
                        New Project with Alternative
                    </MenuItem>
                </Menu>}
            </>

            {showCreate && <CreateAlternative onCancel={() => setShowCreate(false)} onDone={() => {
                altCtx.reload();
                setShowCreate(false)
            }} />}

            {showManage && <ManageAlternatives value={showManage}
                                               onCancel={() => setShowManage(null)}
                                               onDone={() => {
                                                   altCtx.reload();
                                                   setShowManage(null)
                                               }} />}

            {showCreateProject && sys && <AddProjectModal
                defaultUnitSystem={sys}
                onClose={() => setShowCreateProject(false)}
                chooseAlternative={list}
                defaultAlternative={list.find(i => i.id === alt)}
            />}
        </div>
    )
}

const buttonCss = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    margin: 0,
    paddingTop: 1,
    paddingBottom: 1,

    background: "none",
    width: "100%",
    border: "none",
    cursor: "pointer",
    borderRadius: 4,

    "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.1)",
    }
})